import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/search.svg'


const _hoisted_1 = { class: "genericPadding hasHeader hasFooter bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "searchContainer" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "reteContainer my-2 pl-4"
}
const _hoisted_7 = { class: "reteName" }
const _hoisted_8 = { class: "socialDetails" }
const _hoisted_9 = { class: "socialName" }
const _hoisted_10 = { class: "footerButtonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_removable = _resolveComponent("removable")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "ms-1 me-3 d-flex align-items-center",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createVNode("input", {
          type: "text",
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = $event.target.value)),
          ref: "searchInput",
          class: "searchInput ms-2"
        }, null, 544), [
          [_directive_localizedPlaceholder, { key: 'app_utentiBloccati', value: 'Utenti bloccati...' }]
        ])
      ])
    ]),
    (_ctx.filtered.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.localSelected, (item, i) => {
            return (_openBlock(), _createBlock("div", {
              class: "reteItem",
              key: i
            }, [
              _createVNode(_component_removable, {
                onRemove: ($event: any) => (_ctx.select(item))
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock("div", {
                    class: "reteImage",
                    key: item.identifier
                  }, null, 512)), [
                    [_directive_userimage, _ctx.$store.state.getUserImage(item.identifier)]
                  ])
                ]),
                _: 2
              }, 1032, ["onRemove"]),
              _createVNode("div", _hoisted_7, _toDisplayString(item.name), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.filtered.length == 0)
      ? (_openBlock(), _createBlock(_component_localized_text, {
          key: 1,
          localizedKey: "app_nessunutentetrovato",
          text: "Nessun utente trovato",
          class: "fs_14 grey d-block mt-4 text-center"
        }))
      : (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.filtered, (item, i) => {
          return (_openBlock(), _createBlock("div", {
            class: "socialRow",
            key: i,
            onClick: ($event: any) => (_ctx.select(item))
          }, [
            _withDirectives(_createVNode("div", {
              class: ["socialImage", { selected: item.selected }]
            }, null, 2), [
              [_directive_userimage, _ctx.$store.state.getUserImage(item.identifier)]
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, _toDisplayString(item.name), 1)
            ])
          ], 8, ["onClick"]))
        }), 128)),
    _createVNode("div", _hoisted_10, [
      (_ctx.localSelected.length > 0)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: "genericButton bgGreyBlue w-100",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save()))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_sbloccaUtente",
              text: "Sblocca utente",
              class: "fs_14 white"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}